import React from "react";

import RoomHeader from "../RoomHeader";
import TroubleReportController from "./../../../misc/trouble-reports/TroubleReportController";

import { FaWrench } from "react-icons/fa";

const RoomFaultReports = ({ selectedRoom, troubleReportData }) => {
  return (
    <div>
      <RoomHeader
        title="Störungsmeldungen"
        subtitle={selectedRoom.hoersaal}
        icon={<FaWrench className="section-indocator-icon" />}
      />

      <div className="swiper-slide-section">
        <TroubleReportController troubleReportData={troubleReportData} />
      </div>
    </div>
  );
};

export default RoomFaultReports;
